import store from '@/store'
export function fakeUrl (url, fakeUrl) {
  const agFakedData = ['ag352054', 'ag352055', 'ag352056', 'ag352057']
  let path = null
  if (agFakedData.includes(store.state.app.sitimmoUser.login)) {
    path = fakeUrl
  } else {
    path = url
  }
  return path
}
